import { render, staticRenderFns } from "./MediaObject.vue?vue&type=template&id=ceb346b8"
import script from "./MediaObject.vue?vue&type=script&lang=js"
export * from "./MediaObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports